import React from 'react';
import UpdateParentWindow from "../update-parent-window/Updater.js";
import Slider from '../slider/Slider.js';
import SliderConfigs from '../slider/SliderConfigs.js';
import PercentageInput from '../var-inputs/PercentageInput.js';
import EuroInput from '../var-inputs/EuroInput.js';
import ArticleLinks from './ArticleLinks.js';
import {MinusIcon} from "../icons/MinusIcon";
import {PlusIcon} from "../icons/PlusIcon";

class SidePanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {investmentScaleSmall:true};
        this.updateState = this.props.updateState;
        this.animToggleTimer = [];
        this.toggleAnimDuration = 250;
        this.sectionKeys = ['basicinfo', 'projectinfo', 'variables'];
        this.sliders = SliderConfigs({
            changeScaleToLarge: () => {
                if(this.state.investmentScaleSmall) {
                    this.setState({investmentScaleSmall: false});
                }
            },
            yearSliderValidation: this.yearSliderValidation
        });
    }

    initVariables() {
        if(!this.props.state.fundingModels.length || !this.props.state.implementationModels.length) return false;
        this.variables = [
            {
                title: "Laina",
                slug: "laina",
                fields: [
                    {
                        title: "Kokonaiskorko",
                        type: "percentage",
                        stateId: "varsLoanInterest",
                        min: 0.05,
                        max: 10,
                        step: 0.1,
                        decimals: 2,
                        infoText: "Laskuriin syötettävä kokonaiskorko on arviosi lainan korkotasosta sisältäen viitekoron ja marginaalin. Voit muuttaa kokonaiskorkoa ja arvioida sen vaikutusta lainakustannuksiin. Lopullinen viitekorko ja marginaali tarkentuu lainatarjouksessa. Laskurissa laina lyhenee kuukausittain tasalyhennyksin.",
                    },
                ],
            },
            {
                title: "Leasing",
                slug: "leasing",
                fields: [
                    {
                        title: "Kokonaiskorko",
                        type: "percentage",
                        stateId: "varsLeasingInterest",
                        min: 0.05,
                        max: 10,
                        step: 0.1,
                        decimals: 2,
                        infoText: "Laskurin syötettävä kokonaiskorko on arviosi leasingin korkotasosta sisältäen viitekoron ja marginaalin. Voit muuttaa kokonaiskorkoa ja arvioida sen vaikutusta leasingkustannuksiin. Lopullinen viitekorko ja marginaali tarkentuvat leasingtarjouksessa. Laskurissa leasingrahoitus lyhenee kuukausittain annuiteettilyhennyksin (tasaerin).",
                    },
                    {
                        title: "Sopimuskausi",
                        type: "year",
                        stateId: "varsLeasingContractTime",
                        min: 1,
                        max: this.props.state.payBackTime,
                        step: 1,
                        decimals: 0,
                        infoText: "Leasingin sopimuskausi kuvaa leasingrahoituksen kestoa vuosina. Oletuksena sopimuskausi on sama kuin muissakin rahoitusmalleissa. Leasingin sopimuskautta lyhentämällä voit arvioida, mikä vaikutus sillä on rahoituksen kustannuksiin ja jäännösarvoon.",
                    },
                    {
                        title: "Jäännösarvo",
                        type: "percentage",
                        stateId: "varsLeasingResidualValue",
                        min: 1,
                        max: 50,
                        step: 1,
                        decimals: 2,
                        infoText: "Jäännösarvo on sopimuksen pääoma-arvo sopimuskauden lopussa. Jäännösarvo ilmoitetaan prosentteina alkuperäisestä investoinnin hankintahinnasta. Asiakkaalla on optio sopimuskauden loppuessa maksaa jäännösarvo (ostaa vuokrakohde) tai optio jatkaa sopimuskautta tai velvollisuus osoittaa kohteelle ostaja. Laskuri olettaa asiakkaan maksavan jäännösarvon sopimuskauden viimeisenä päivänä.",
                    },
                ],
            },
            {
                title: "Vihreä laina",
                slug: "vihrea-rahoitus",
                fields: [
                    {
                        title: "Kokonaiskorko",
                        type: "percentage",
                        stateId: "varsGreenLoanInterest",
                        min: 0.05,
                        max: 10,
                        step: 0.1,
                        decimals: 2,
                        infoText: "Laskuriin syötettävä kokonaiskorko on arviosi lainan korkotasosta sisältäen viitekoron ja marginaalin. Voit muuttaa kokonaiskorkoa ja arvioida sen vaikutusta lainakustannuksiin. Lopullinen viitekorko ja marginaali tarkentuu lainatarjouksessa. Laskurissa laina lyhenee kuukausittain tasalyhennyksin.",
                    },
                ],
            },
            {
                title: "Vihreä leasing",
                slug: "vihrea-leasing",
                fields: [
                    {
                        title: "Kokonaiskorko",
                        type: "percentage",
                        stateId: "varsGreenLeasingInterest",
                        min: 0.05,
                        max: 10,
                        step: 0.1,
                        decimals: 2,
                        infoText: "Laskurin syötettävä kokonaiskorko on arviosi leasingin korkotasosta sisältäen viitekoron ja marginaalin. Voit muuttaa kokonaiskorkoa ja arvioida sen vaikutusta leasingkustannuksiin. Lopullinen viitekorko ja marginaali tarkentuvat leasingtarjouksessa. Laskurissa leasingrahoitus lyhenee kuukausittain annuiteettilyhennyksin (tasaerin).",
                    },
                    {
                        title: "Sopimuskausi",
                        type: "year",
                        stateId: "varsGreenLeasingContractTime",
                        min: 1,
                        max: this.props.state.payBackTime,
                        step: 1,
                        decimals: 0,
                        infoText: "Leasingin sopimuskausi kuvaa leasingrahoituksen kestoa vuosina. Oletuksena sopimuskausi on sama kuin muissakin rahoitusmalleissa. Leasingin sopimuskautta lyhentämällä voit arvioida, mikä vaikutus sillä on rahoituksen kustannuksiin ja jäännösarvoon.",
                    },
                    {
                        title: "Jäännösarvo",
                        type: "percentage",
                        stateId: "varsGreenLeasingResidualValue",
                        min: 1,
                        max: 50,
                        step: 1,
                        decimals: 2,
                        infoText: "Jäännösarvo on sopimuksen pääoma-arvo sopimuskauden lopussa. Jäännösarvo ilmoitetaan prosentteina alkuperäisestä investoinnin hankintahinnasta. Asiakkaalla on optio sopimuskauden loppuessa maksaa jäännösarvo (ostaa vuokrakohde) tai optio jatkaa sopimuskautta tai velvollisuus osoittaa kohteelle ostaja. Laskuri olettaa asiakkaan maksavan jäännösarvon sopimuskauden viimeisenä päivänä.",
                    },
                ],
            },
            {
                //title: this.props.state.implementationModels.filter(item => item.slug === "pitka-vuokra")[0].title,
                title: "Vuokra",
                slug: "vuokra",
                fields: [
                    {
                        title: "Alkuvuokra",
                        type: "percentage",
                        stateId: "varsLongRentInitialRent",
                        min: 0.05,
                        max: 30,
                        step: 0.5,
                        decimals: 2,
                        infoText: "Alkuvuokra on tuottoprosentti, joka toimii ensimmäisen vuoden pituisen vuokrakauden laskentaperusteena. Laskurin esittämä tuottoprosentti perustuu Kuntarahoituksen oletukseen pitkän vuokrasopimuksen tuottovaateesta. Markkinakäytännön mukaan mm. kohteen sijainti, tyyppi, riskisyys ja vuokrakauden pituus vaikuttavat suuresti tavoiteltuun alkuvuokraan. Voit päivittää laskuriin omaan hankkeeseesi soveltuvan tuottoprosentin.",
                    },
                    {
                        title: "Indeksointi",
                        type: "percentage",
                        stateId: "varsLongRentIndexing",
                        min: 0.00,
                        max: 10,
                        step: 0.05,
                        decimals: 2,
                        infoText: "Tyypillisesti vuokratasoa indeksoidaan sopimuksessa siinä määritetyn kustannusindeksin vuosimuutoksella. Laskurin oletusarvio perustuu yleiseen 2 %:n pitkän aikavälin inflaatio-odotukseen. Voit muuttaa laskurin inflaatio-odotusta. Laskuri huomioi indeksoinnin kunkin vuoden lopussa.",
                    },
                    {
                        title: "Lunastushinta",
                        type: "euro",
                        stateId: "varsLongRentRedemptionValue",
                        min: 0.00,
                        max: 999.99,
                        decimals: 2,
                        infoText: "Joihinkin vuokrasopimuksiin on mahdollista neuvotella optio lunastaa kohde. Voit arvioida laskurilla lunastuksen vaikutusta kokonaiskustannukseen lisäämällä siihen lunastushinta. Lunastus huomioidaan laskurissa sopimuskauden lopuksi.",
                    },
                ],
            },
            {
                //title: this.props.state.implementationModels.filter(item => item.slug === "lyhyt-vuokra")[0].title,
                title: "Lyhytaikainen vuokra", // TODO: change this when api serves the right implementation data
                slug: "lyhytaikainen-vuokra",
                fields: [
                    {
                        title: "Alkuvuokra",
                        type: "percentage",
                        stateId: "varsShortRentInitialRent",
                        min: 0.05,
                        max: 30,
                        step: 0.5,
                        decimals: 2,
                        infoText: "Alkuvuokra on tuottoprosentti, joka toimii ensimmäisen vuoden pituisen vuokrakauden laskentaperusteena. Laskurin esittämä tuottoprosentti perustuu Kuntarahoituksen oletukseen lyhyen vuokrasopimuksen tuottovaateesta. Markkinakäytännön mukaan mm. kohteen sijainti, tyyppi, riskisyys ja vuokrakauden pituus vaikuttavat suuresti tavoiteltuun alkuvuokraan. Voit päivittää laskuriin omaan hankkeeseesi soveltuvan tuottoprosentin.",
                    },
                    {
                        title: "Indeksointi",
                        type: "percentage",
                        stateId: "varsShortRentIndexing",
                        min: 0.00,
                        max: 10,
                        step: 0.05,
                        decimals: 2,
                        infoText: "Tyypillisesti vuokratasoa indeksoidaan sopimuksessa siinä määritetyn kustannusindeksin vuosimuutoksella. Laskurin oletusarvio perustuu yleiseen 2 %:n pitkän aikavälin inflaatio-odotukseen. Voit muuttaa laskurin inflaatio-odotusta. Laskuri huomioi indeksoinnin kunkin vuoden lopussa.",
                    },
                    {
                        title: "Lunastushinta",
                        type: "euro",
                        stateId: "varsShortRentRedemptionValue",
                        min: 0.00,
                        max: 999.99,
                        decimals: 2,
                        infoText: "Joihinkin vuokrasopimuksiin on mahdollista neuvotella optio lunastaa kohde. Voit arvioida laskurilla lunastuksen vaikutusta kokonaiskustannukseen lisäämällä siihen lunastushinnan. Lunastus huomioidaan laskurissa sopimuskauden lopuksi.",
                    },
                ],
            },
        ];
        return true;
    }

    yearSliderValidation(newVal, oldVal) {
        newVal = newVal.toString().replace(",",".");
        if(isNaN(newVal)) return oldVal;
        return Math.round(newVal);
    }

    createSection(key) {
        switch(key) {
            case 'basicinfo':
                return this.sectionBasicInfo();
            case 'projectinfo':
                return this.sectionProjectInfo();
            case 'variables':
                return this.sectionVariables();
            default:
                return null;
        }
    }

    sectionBasicInfo() {
        if(this.props.state.phase === 4) {
            return (
                <div>
                    <div className="conclusion-set">
                        <div className="conclusion-label">Investoinnin koko</div>
                        <div className="conclusion-value">{this.props.state.investmentSize.toString().replace(".",",")} milj. &euro;</div>
                    </div>
                    <div className="conclusion-set">
                        <div className="conclusion-label">Rahoitusaika</div>
                        <div className="conclusion-value">{this.props.state.payBackTime} vuotta</div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="change-scale">
                        Max.
                        <button onClick={() => {
                            let newScaleSmall = !this.state.investmentScaleSmall;
                            this.sliders.investmentSize.changeScale(newScaleSmall);
                            this.setState({investmentScaleSmall:newScaleSmall})
                        }} aria-label={"Aseta skaalauksen maksimiksi "+(this.state.investmentScaleSmall ? this.sliders.investmentSize.largeScaleMax : this.sliders.investmentSize.smallScaleMax)+" Miljoonaa Euroa."}>
                            {this.sliders.investmentSize.smallScaleMax}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.sliders.investmentSize.largeScaleMax}
                            <span className={"selected-scale-indicator"+(this.state.investmentScaleSmall ? " left" : " right")}>
                                {this.state.investmentScaleSmall ? this.sliders.investmentSize.smallScaleMax : this.sliders.investmentSize.largeScaleMax}
                            </span>
                        </button>
                        M €
                    </div>
                    <Slider
                        state={this.props.state}
                        id="investmentSize"
                        updateState={this.updateState}
                        resizeFns={this.props.resizeFns}
                        sliderConfig={this.sliders}
                        key={this.state.investmentScaleSmall ? "investmentSizeSmall" : "investmentSizeLarge"}>
                    </Slider>
                    <Slider
                        state={this.props.state}
                        id="payBackTime"
                        updateState={this.updateState}
                        resizeFns={this.props.resizeFns}
                        sliderConfig={this.sliders}>
                    </Slider>
                </div>
            );
        }
    }

    sectionProjectInfo() {
        if(this.props.state.phase === 4) {
            return (
                <div className="conclusion-set">
                    <div className="conclusion-label">Valmistumisvuosi</div>
                    <div className="conclusion-value">{this.props.state.completionYear}</div>
                </div>
            );
        } else {
            return <div>
                <Slider
                    state={this.props.state}
                    id="completionYear"
                    updateState={this.updateState}
                    resizeFns={this.props.resizeFns}
                    sliderConfig={this.sliders}>
                </Slider>
            </div>;
        }
    }

    sectionVariables() {
      let state = this.props.state;
      let fundingSlugs = this.props.state.fundingModels.map(m => state.phase === 1 ? m.slug :
                                                                 state.phase === 2 ?
                                                                    (state.availableFundingModels.map(fm => fm.slug).includes(m.slug) ? m.slug : null) :
                                                                    (state.selectedFundings.includes(m.slug) ? m.slug : null));

        return <div className="variables">
            {this.variables.map(item => {
                                  var fm = this.props.state.fundingModels.filter(fm => fm.slug === item.slug);
                                  item["order"] = fm.length ? fm[0].order : 0;
                                  return item;})
                           .sort((a, b) => a.order - b.order)
                           .map((item, parentIndex) => {
              if (fundingSlugs.includes(item.slug)) {
                return <div key={"variables-item-"+parentIndex} className="variables-item">
                    <h4>{item.title}</h4>
                    {item.fields.map((field, index) => {
                        switch(field.type) {
                            case 'percentage':
                                return this.props.state.phase === 4 ?
                                    <div className="conclusion-set" key={"conclusion-"+(field.stateId)}>
                                        <div className="conclusion-label">{field.title}</div>
                                        <div className="conclusion-value">{this.showDecimalValue(this.props.state[field.stateId])} %</div>
                                    </div>
                                    :
                                    <PercentageInput
                                        state={this.props.state}
                                        updateState={this.props.updateState}
                                        index={index}
                                        parentIndex={parentIndex}
                                        field={field}
                                        key={"percentage-input-"+parentIndex+"-"+index}>
                                    </PercentageInput>
                            case 'year':
                                return this.props.state.phase === 4 ?
                                    <div className="conclusion-set" key={"conclusion-"+(field.stateId)}>
                                        <div className="conclusion-label">{field.title}</div>
                                        <div className="conclusion-value">{this.showDecimalValue(this.props.state[field.stateId])} v</div>
                                    </div>
                                    :
                                    <PercentageInput
                                        state={this.props.state}
                                        updateState={this.props.updateState}
                                        index={index}
                                        parentIndex={parentIndex}
                                        field={field}
                                        unit="v"
                                        key={"percentage-input-"+parentIndex+"-"+index}>
                                    </PercentageInput>
                            case 'euro':
                                return this.props.state.phase === 4 ?
                                    <div className="conclusion-set" key={"conclusion-"+(field.stateId)}>
                                        <div className="conclusion-label">{field.title}</div>
                                        <div className="conclusion-value">{this.showDecimalValue(this.props.state[field.stateId])} milj. &euro;</div>
                                    </div>
                                    :
                                    <EuroInput
                                        state={this.props.state}
                                        updateState={this.props.updateState}
                                        index={index}
                                        parentIndex={parentIndex}
                                        field={field}
                                        key={"euro-input-"+parentIndex+"-"+index}>
                                    </EuroInput>
                            default:
                                return null;
                        }
                    })}
                </div>
              } else return null;
            })}
        </div>
    }

    showDecimalValue(value) {
        value = (+value).toFixed(2);
        return value.toString().replace(".", ",");
    }

    interestItem(item) {
        return <div className="interests__item">
            {item.title}
        </div>;
    }

    toggleSection(key) {
        if(this.animToggleTimer[key]) clearTimeout(this.animToggleTimer[key]);
        let thisSection = this.props.state.sidePanelSections[key],
            newState = Object.assign({}, thisSection, {open: thisSection.open, toggling: true});
        this.props.updateState(state => ({
            sidePanelSections: Object.assign({}, this.props.state.sidePanelSections, {[key]: newState})
        }));
        setTimeout(() => {
            thisSection = this.props.state.sidePanelSections[key];
            newState = Object.assign({}, thisSection, {open: !thisSection.open, toggling: true});
            this.props.updateState(state => ({
                sidePanelSections: Object.assign({}, this.props.state.sidePanelSections, {[key]: newState})
            }));
            let fns = Object.keys(this.props.resizeFns);
            fns.forEach((fn) => {
                this.props.resizeFns[fn]();
            });
        },20);
        this.animToggleTimer[key] = setTimeout(() => {
            thisSection = this.props.state.sidePanelSections[key];
            newState = Object.assign({}, thisSection, {open: thisSection.open, toggling: false});
            this.props.updateState(state => ({
                sidePanelSections: Object.assign({}, this.props.state.sidePanelSections, {[key]: newState})
            }));
            clearTimeout(this.animToggleTimer[key]);
            setTimeout(() => {UpdateParentWindow(this.props.state, this.props.updateState);},0);
        }, this.toggleAnimDuration);
    }

    collapsableWrapper(c, key) {
        return (
            <div className={"collapsable-container " + key +
                (this.props.state.sidePanelSections[key].open ? " open" : " closed") +
                (this.props.state.sidePanelSections[key].toggling ? " toggling" : "")} key={key}>
                <div className="section-title">
                    {this.props.state.sidePanelSections[key].title}
                    <button className="collapse-button" onClick={this.toggleSection.bind(this, key)}>
                        {this.props.state.sidePanelSections[key].open ? <MinusIcon marginToTop={3} /> : <PlusIcon marginToTop={3} />}
                    </button>
                </div>
                <div className="section-content" style={{transitionDuration: this.toggleAnimDuration + "ms"}}>
                    {c}
                </div>
            </div>
        );
    }

    componentWillMount() {
        if(this.props.state.investmentSize > this.sliders.investmentSize.smallScaleMax &&
            this.state.investmentScaleSmall) {
             this.sliders.investmentSize.changeScale(false);
             this.setState({investmentScaleSmall: false});
        }
    }

    sidePanelContent() {
        let contentKeys = this.sectionKeys,
            firstTwoWrapper = [],
            content = [],
            c;
        contentKeys.forEach((key, index) => {
            c = this.createSection(key);
            if(c) {
                if(index === 0 || index === 1) {
                    firstTwoWrapper.push(this.collapsableWrapper(c, key));
                } else if(index === 2) {
                    content.push(<div className="first-two-container" key="first-two-container">{firstTwoWrapper}</div>);
                    content.push(this.collapsableWrapper(c, key));
                } else {
                    content.push(this.collapsableWrapper(c, key));
                }
            }
        });
        return content;
    }

    render() {
        if(this.initVariables()) {
            return (
                <div>
                    <div className="side-panel">
                        <h3>Hankkeen tiedot</h3>
                        <div className="side-panel__content">
                            {this.sidePanelContent()}
                        </div>
                    </div>
                    <div className={"side-panel side-panel--article-links"+
                        (!this.props.state.articleLinks || !this.props.state.articleLinks.length ? " side-panel--hide" : "")}>
                        <h3>Tutustu kohteisiin ratkaisupankissa</h3>
                        <ArticleLinks state={this.props.state} updateState={this.props.updateState}></ArticleLinks>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default SidePanel;
